/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import type { SchemaOrgNode } from './schema-org-node.model';

/**
 * Browser-side no-op implementation. The real schema collection runs in
 * `ServerSchemaService` (SSR-only); on the client these methods are stubbed
 * so consumers can call them unconditionally without `isPlatformBrowser`
 * guards. The unused parameters are part of the public API signature.
 */
@Injectable({ providedIn: 'root' })
export class SchemaService {
  register(_fragment: SchemaOrgNode | SchemaOrgNode[] | null): void {
    // No-op on browser - SSR only
  }

  /**
   * Registers CMS-authored nodes that are authoritative over component-emitted
   * nodes: on an `@id` collision the CMS values win (deep-merged), independent of
   * registration order. See `ServerSchemaService` for the real implementation.
   */
  registerAuthoritative(_fragment: SchemaOrgNode | SchemaOrgNode[] | null): void {
    // No-op on browser - SSR only
  }

  /**
   * @param _fallback Optional node to add only if no node with the same `@id` was registered.
   * Useful for ensuring a baseline `EducationalOrganization` exists so cross-references
   * like `Course.provider` always resolve.
   */
  finalize(_fallback?: SchemaOrgNode | null): void {
    // No-op on browser - SSR only
  }
}
